import React from 'react';
import {useTranslation} from "react-i18next";
import { CURRENT_YEAR } from './constants/constant';



function Footer() {
    const {t} = useTranslation()
    return (
        <div className="bottom-bar">
            <div className="copy-right">
                <img src="/assets/verse.svg" alt="Logo"/>
                {t(`©${CURRENT_YEAR} ANIMOCA BRANDS LIMITED - ALL RIGHTS RESERVED`)}
            </div>
            <div className="right-images text-uppercase">
                <a className={"mr-2"} href="">{t("Terms Of Service")}</a>
                <a href="">{t("Privacy Policy")}</a>
            </div>
        </div>
    );
}

export default Footer;